import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { alpha } from "@mui/material/styles";
import { Chip, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { MUESTRA_ESTADOS, muestraEstadoColor } from "./feriaStatus";

/**
 * Chip de estado de muestra; opcionalmente abre menú para cambiarlo.
 */
const FeriaEstadoChip = ({
  estado,
  onChange,
  size = "small",
  editable = false,
  sx = {},
}) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState(null);
  const color = muestraEstadoColor(estado);
  const label = t(`FeriasPage.estado.${estado || "none"}`);

  const chipSx = {
    fontWeight: 700,
    height: size === "small" ? 22 : 28,
    fontSize: size === "small" ? "0.68rem" : "0.75rem",
    bgcolor: alpha(color, 0.14),
    color,
    maxWidth: "100%",
    "& .MuiChip-label": { px: 1 },
    ...(editable
      ? {
          cursor: "pointer",
          "& .MuiChip-deleteIcon": { color, fontSize: "1.1rem", ml: -0.25 },
        }
      : {}),
    ...sx,
  };

  if (!editable) {
    return <Chip size={size} label={label} sx={chipSx} />;
  }

  return (
    <>
      <Chip
        size={size}
        label={label}
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        onDelete={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        deleteIcon={<KeyboardArrowDownIcon />}
        sx={chipSx}
      />
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {MUESTRA_ESTADOS.map((st) => {
          const c = muestraEstadoColor(st);
          return (
            <MenuItem
              key={st}
              selected={st === estado}
              onClick={async (e) => {
                e.stopPropagation();
                setAnchor(null);
                if (st !== estado && onChange) await onChange(st);
              }}
            >
              <Chip
                size="small"
                label={t(`FeriasPage.estado.${st}`)}
                sx={{
                  fontWeight: 700,
                  bgcolor: alpha(c, 0.14),
                  color: c,
                }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default FeriaEstadoChip;
